import { Action, ActionType, Docusign } from "../model";
import createReducer from "./createReducer";

export const docusign = createReducer<Docusign>({ evvelopeUrl: '' }, {
	[ActionType.GET_ENVELOPE](state: Docusign, action: Action<Docusign>) {
		return action.payload;
	},
});
